import React from 'react';
import { Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import ProductGroups from './ProductGroups';
import ProductGroupDetails from './ProductGroupDetails/ProductGroupDetails';

export function ProductGroupsRoute() {
  const { updatePageTitle } = usePageTitle();

  updatePageTitle('Product Groups - GDE');

  return (
    <NestedApiLocalizationProvider
      preloadResources={[
        'CustomerGroups',
        'ProductGroups',
        'Common',
        'Pagination',
      ]}
    >
      <Routes>
        <Route element={<ProductGroups />} path="" />
        <Route element={<ProductGroupDetails />} path="/:id" />
      </Routes>
    </NestedApiLocalizationProvider>
  );
}
